import { useTranslations } from 'next-intl';
import { Card } from '@/models/card';

export interface IProps {
  card: Card;
  isSelectable?: boolean;
  onCardClicked?: any;
}

export default function CardCheckoutDisplay(props: IProps) {
  const { brand, last4, token } = props.card;
  const t = useTranslations('checkout');
  return (
    <div
      className="checkout-selection-item checkout-selection-item-hoverable row m-0 mb-1"
      style={{
        display: 'flex',
        cursor: props.isSelectable ? 'pointer' : 'default',
      }}
      onClick={
        props.isSelectable ? () => props.onCardClicked(props.card) : () => null
      }
    >
      {props.isSelectable && (
        <div className="pt-2 pr-1 pl-1 custom-control custom-radio align-self-center">
          <input
            className="custom-control-input"
            id={'card ' + token}
            type="radio"
            name="cardRadio"
            onClick={() => props.onCardClicked(props.card)}
          />
          <label
            className="custom-control-label"
            htmlFor={'card ' + token}
          ></label>
        </div>
      )}

      <div className="col pr-0 pl-0">
        <div className="flex-column align-items-start">
          <div className="d-flex w-100 justify-content-between">
            <span>{brand}</span>
          </div>
          <small className="opacity-60">
            {t('CardCheckoutDisplay.ends-with')} {last4}
          </small>
        </div>
      </div>

      {props.isSelectable && (
        <div
          className="col-auto text-right pr-0 align-self-center"
          style={{ fontSize: '18px', color: '#666' }}
        >
          <i
            className="icon-arrow-right mt-0"
            style={{ verticalAlign: 'text-top' }}
          />
        </div>
      )}
    </div>
  );
}
